//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import flick from '@/mixins/Flickity.js'
export default {
  mixins: [flick],
  props: ['professores'],
  data() {
    return {
      dialog: false,
      doFlick: true,
      selectedProfessor: {},
      options: {
        // groupCells: 5,
        cellAlign: 'center',
      },
    }
  },
  computed: {
    itemsCount: (v) => v.professores && v.professores.length,
  },
}
